module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/merit-japan-c3cf3f377ff9b4db43e88cf3fd805e2c.png";